<template>
  <button class="remove" @click="removeItem(index)">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><title>Ukloni proizvod</title><path fill="currentColor" d="M12 12h2v12h-2zM18 12h2v12h-2z"/><path fill="currentColor" d="M4 6v2h2v20a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8h2V6zm4 22V8h16v20zM12 2h8v2h-8z"/></svg>
  </button>
</template>

<script>
  export default {
    name: "remove-icon",

    props: [
			'index',
	    'product'
    ],

    methods: {

      /**
       * Remove product from Shopping cart by sending request to backend.
       *
       * @param index
       */
      removeItem(index) {

	      axios.post('/izbaci-iz-korpe/' + index)
		      .then(response => {

			      this.$toasted.global.toastSuccess({message: 'Proizvod je uspešno uklonjen iz korpe'});

			      // Update vuex store
			      this.$store.dispatch('Cart/changeCartItems', response.data.cartItems);
			      this.$store.dispatch('Cart/changeItemCount', response.data.cartItemsCount);
			      this.$store.dispatch('Cart/changeTotalPrice', response.data.totalPrice);
			      this.$store.dispatch('Cart/changeSubTotalPrice', response.data.subTotalPrice);
			      this.$store.dispatch('Cart/changeTotalWithoutPDV', response.data.totalWithoutPDV);
			      this.$store.dispatch('Cart/changeTotalPDV', response.data.totalPDV);
			      this.$store.dispatch('Cart/changeCoupon', response.data.coupon);


		      })
		      .catch(e => {

		      })

	      dataLayer.push({ecommerce: null});  // Clear the previous ecommerce object.
	      dataLayer.push({
		      event: "remove_from_cart",
		      ecommerce: {
			      currency: "RSD",
			      value: this.product.price_small,
			      items: [
				      {
					      item_id: this.product.id,
					      item_name: this.product.title,
					      //affiliation: "Google Merchandise Store",
					      coupon: '',
					      discount: 0,
					      index: 0,
					      item_brand: this.product.brand.title,
					      item_category: this.product.categories[1].title,
					      item_list_id: "Cart",
					      price: this.product.price_small,
					      quantity: 1
				      }
			      ]
		      }
	      });
      }
    }
  }
</script>